import type { AddressTypeEnum } from '@/modules/core/models/enums'

export default class AddressDetails {
  private _postalCode!: string | null
  private _country!: string | null
  private _province!: string | null
  private _city!: string | null
  private _cityCode!: string | null
  private _address!: string | null
  private _houseType!: string | null
  private _roadNumber!: string | null
  private _gateway!: string | null
  private _stair!: string | null
  private _floor!: string | null
  private _doorway!: string | null
  private _addressExtra!: string | null
  private _streetType!: string | null
  private _type!: AddressTypeEnum | null
  private _addressNormalize!: boolean | null

  public editable: boolean

  constructor(data: any = {}) {
    this.postalCode = data.postalCode || data._postalCode
    this.country = data.country || data._country
    this.province = data.province || data._province
    this.city = data.city || data._city
    this.cityCode = data.cityCode || data._cityCode
    this.address = data.address || data._address
    this.houseType = data.houseType || data._houseType
    this.roadNumber = data.roadNumber || data._roadNumber
    this.gateway = data.gateway || data._gateway
    this.stair = data.stair || data._stair
    this.floor = data.floor || data._floor
    this.doorway = data.doorway || data._doorway
    this.addressExtra = data.addressExtra || data._addressExtra
    this.streetType = data.streetType || data._streetType
    this.type = [null, undefined].includes(data.type) ? null : data.type
    this.addressNormalize = data.addressNormalize || data._addressNormalize

    this.editable = typeof data.editable === 'boolean' ? data.editable : true
  }

  get postalCode(): string | null {
    return this._postalCode
  }
  set postalCode(value: string | null | undefined) {
    this._postalCode = value ?? null
  }
  get provinceCode(): string | null {
    return this.postalCode?.slice(0, 2) ?? null
  }

  get country(): string | null {
    return this._country
  }
  set country(value: string | null | undefined) {
    this._country = value ?? null
  }

  get province(): string | null {
    return this._province
  }
  set province(value: string | null | undefined) {
    this._province = value ?? null
  }

  get city(): string | null {
    return this._city
  }
  set city(value: string | null | undefined) {
    this._city = value ?? null
  }

  get cityCode(): string | null {
    return this._cityCode
  }
  set cityCode(value: string | null | undefined) {
    this._cityCode = value ?? null
  }

  get address(): string | null {
    return this._address
  }
  set address(value: string | null | undefined) {
    this._address = value ?? null
  }

  // houseType
  get houseType(): string | null {
    return this._houseType
  }
  set houseType(value: string | null | undefined) {
    this._houseType = value ?? null
  }

  get roadNumber(): string | null {
    return this._roadNumber
  }
  set roadNumber(value: string | null | undefined) {
    this._roadNumber = value ?? null
  }

  // gateway
  get gateway(): string | null {
    return this._gateway
  }
  set gateway(value: string | null | undefined) {
    this._gateway = value ?? null
  }

  // stair
  get stair(): string | null {
    return this._stair
  }
  set stair(value: string | null | undefined) {
    this._stair = value ?? null
  }

  // floor
  get floor(): string | null {
    return this._floor
  }
  set floor(value: string | null | undefined) {
    this._floor = value ?? null
  }

  // doorway
  get doorway(): string | null {
    return this._doorway
  }
  set doorway(value: string | null | undefined) {
    this._doorway = value ?? null
  }

  get addressExtra(): string | null {
    return this._addressExtra
  }
  set addressExtra(value: string | null | undefined) {
    this._addressExtra = value ?? null
  }

  get streetType(): string | null {
    return this._streetType
  }
  set streetType(value: string | null | undefined) {
    this._streetType = value ?? null
  }

  get type(): AddressTypeEnum | null {
    return this._type
  }
  set type(value: AddressTypeEnum | null | undefined) {
    this._type = value ?? null
  }

  get addressNormalize(): boolean | null {
    return this._addressNormalize
  }
  set addressNormalize(value: boolean | null | undefined) {
    this._addressNormalize = value ?? null
  }

  getCompleteAddress() {
    let addBreak = false
    let address = `${this.address}`
    if (this.roadNumber) {
      address += `, ${this.roadNumber}\n`
    }
    if (this.gateway) {
      address += `, Portal ${this.gateway}`
      addBreak = true
    }
    if (this.stair) {
      address += `, Esc. ${this.stair}`
      addBreak = true
    }
    if (this.floor) {
      address += `, Piso ${this.floor}`
      addBreak = true
    }
    if (this.doorway) {
      address += `, Pta. ${this.doorway}`
      addBreak = true
    }
    if (addBreak) {
      address += '\n'
    }
    if (this.addressExtra) {
      address += `${this.addressExtra}\n`
    }
    address += `${this.postalCode} ${this.city}\n${this.province}`
    return address.replace(/null/gi, '').replace('\n, ', '\n')
  }

  updateAttributes(newAttributes: Partial<AddressDetails>) {
    Object.assign(this, newAttributes)
  }
}
